import { render, staticRenderFns } from "./MenuPreview.vue?vue&type=template&id=fc9012a0&scoped=true&"
import script from "./MenuPreview.vue?vue&type=script&lang=js&"
export * from "./MenuPreview.vue?vue&type=script&lang=js&"
import style0 from "./MenuPreview.vue?vue&type=style&index=0&id=fc9012a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc9012a0",
  null
  
)

export default component.exports